<!-- Nothing is rendered until something is actually selected: showing a placeholder price here
     reads as a real quote for a product the user never picked. -->
<div class="subscription-cart-preview text-light" *ngIf="vm$ | async as vm">
  <!-- "Abonnement" only fits a summary holding one subscription and nothing else; anything the buyer
       combined — several subscriptions, or gift cards next to them — is an order. -->
  <span class="subscription-cart-preview-title"
    >{{
      (vm.giftCards.length || vm.subscriptions.length > 1 ? 'cart.your_order' : 'subscriptions.summary.title')
        | transloco
    }}:</span
  >

  <!-- What the plan costs per period, and nothing else: no pro-rata, no fee, no discount. Those are
       the first-invoice block's, so that neither number has to be read as the other. One row per
       subscription bought, never a counted one (PAUL-3171). -->
  <div class="subscription-cart-preview-items">
    <ng-container *ngFor="let row of vm.subscriptions">
      <div class="subscription-cart-preview-row d-flex justify-content-between">
        <span>{{ row.name }}</span>
        <strong>
          {{ row.price | localeCurrency: 'EUR'
          }}<ng-container *ngIf="row.periodLabelKey"> {{ row.periodLabelKey | transloco }}</ng-container>
        </strong>
      </div>

      <!-- The joining fee, on the steps that show no invoice yet: a price the buyer will be charged
           should not first appear on the payment step (PAUL-3170). Under the subscription that pays
           it, since it is reported per line and one order may hold several. -->
      <div
        class="subscription-cart-preview-row subscription-cart-preview-subrow d-flex justify-content-between"
        *ngIf="row.setupFee !== null"
      >
        <span>{{ row.setupFeeLabel || ('subscriptions.summary.setup_fee' | transloco) }}</span>
        <strong>{{ row.setupFee | localeCurrency: 'EUR' }}</strong>
      </div>
    </ng-container>

    <div class="subscription-cart-preview-row d-flex justify-content-between" *ngFor="let giftCard of vm.giftCards">
      <span>{{ giftCard.name }}</span>
      <strong>{{ giftCard.unitPrice | localeCurrency: giftCard.currency }}</strong>
    </div>
  </div>

  <!-- What is being paid now, charge by charge and with the days each one buys — the pro-rated first
       period, the discount over its own window, the one-off fee over none. -->
  <ng-container *ngIf="vm.firstInvoice">
    <span class="subscription-cart-preview-title">{{ 'subscriptions.summary.first_invoice' | transloco }}:</span>

    <div class="subscription-cart-preview-items">
      <div
        class="subscription-cart-preview-invoice-row"
        [class.subscription-cart-preview-subrow]="row.child"
        *ngFor="let row of vm.firstInvoice"
      >
        <span>
          {{ row.label || (row.labelKey | transloco)
          }}<ng-container *ngIf="row.productName"> ({{ row.productName }})</ng-container>
        </span>
        <!-- Always rendered, so the amounts stay in one column. The end is the last day covered, not
             the API's exclusive one — see the component. -->
        <span class="subscription-cart-preview-window">{{
          row.window
            ? ('subscriptions.summary.period_range' | transloco: { from: row.window.from, to: row.window.to })
            : ''
        }}</span>
        <strong>{{ row.amount | localeCurrency: 'EUR' }}</strong>
      </div>
    </div>
  </ng-container>

  <!-- While the buyer is still choosing, recurring plans have no total at all (see `total` in the
       component); on the payment step it is the invoice above, about to be debited. -->
  <div
    class="subscription-cart-preview-summary d-flex justify-content-between"
    *ngIf="!hideSummary && vm.total !== null"
  >
    <strong class="text-bold text-md">{{ vm.totalLabelKey | transloco }}:</strong>
    <strong class="text-bold text-md">{{ vm.total | localeCurrency: 'EUR' }}</strong>
  </div>
</div>
